import { CustomField, CustomFieldTypes, SUPPORTED_CUSTOM_FIELDS } from '../models/aircraft';

export interface Field {
  key: string;
  view: string;
  title: string;
}

export interface PrecisionField extends Field {
  precision: number;
}

export interface MinMaxField extends Field {
  min: number | string;
  max: number | string;
  type: string;
}

const NUMERIC_CUSTOM_FIELD_TYPES = [
  CustomFieldTypes.NUMBER,
  CustomFieldTypes.COUNTER,
  CustomFieldTypes.DURATION,
];

export const getCustomFieldDefaultValue = (field: CustomField): string | number | null => {
  if (field?.default === undefined || field?.default === null || field.default === '') {
    return null;
  }

  if (NUMERIC_CUSTOM_FIELD_TYPES.includes(field.type)) {
    const parsed = Number(field.default);
    if (Number.isNaN(parsed)) {
      return null;
    }
    return parsed;
  }

  return field.default;
};

export const getRequiredFields = (fields: { [key: string]: CustomField }): Field[] => {
  if (!fields) return [];
  const entries = Object.entries(fields);
  const required = entries
    .filter((entry: [string, CustomField] ) => SUPPORTED_CUSTOM_FIELDS.includes(entry[1].type) && entry[1].required)
    .map(([key, data]: [string, CustomField]) => {
      return { key, view: data?.view, title: data?.heading || data?.title };
    });
  return required;
};

export const getPrecisionFields = (fields: { [key: string]: CustomField }): PrecisionField[] => {
  if (!fields) return [];
  const entries = Object.entries(fields);
  const required = entries
    .filter((entry: [string, CustomField] ) => entry[1].type === 'number' && entry[1].precision)
    .map(([key, data]: [string, CustomField]) => {
      return { key, view: data?.view, title: data?.heading || data?.title, precision: data?.precision };
    });
  return required;
};

export const getMinMaxFields = (fields: { [key: string]: CustomField }): MinMaxField[] => {
  if (!fields) return [];
  const entries = Object.entries(fields);
  const required = entries
    .filter(
      (entry: [string, CustomField] ) =>
        (entry[1].type === 'number' || entry[1].type === 'string' || entry[1].type === 'text') &&
        (entry[1].min || entry[1].max),
    )
    .map(([key, data]: [string, CustomField]) => {
      return {
        key,
        view: data?.view,
        title: data?.heading || data?.title,
        min: data?.min,
        max: data?.max,
        type: data?.type,
      };
    });
  return required;
};
